import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';
import { datadogEnvironment } from '@config/services';

const DISCARD_MESSAGES = new Set([
  'ResizeObserver loop completed with undelivered notifications.',
]);

const shouldDiscardLog = (log: LogsEvent): boolean =>
  DISCARD_MESSAGES.has(log.message);

export function collectDatadogLogs(): void {
  datadogLogs.init({
    clientToken: 'pub03bc6cb5719a19cf8e186d0859aafde5',
    env: datadogEnvironment,
    forwardErrorsToLogs: true,
    service: 'pharmacy_portal_fe',
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    useSecureSessionCookie: true,
    version: import.meta.env.VITE_GITHUB_SHA ?? 'unknown',

    beforeSend(log: LogsEvent): boolean {
      // ONLY log if in production, qa, or preprod
      if (!datadogEnvironment) {
        return false;
      }

      if (shouldDiscardLog(log)) {
        return false;
      }

      // Remove potentially sensitive query params from URLs
      log.view.url = log.view.url.replace(/email=[^&]*/g, 'email=REDACTED');

      return true;
    },
  });
}
